var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendencias(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.755,
    height: 117.973,
    viewBox: "0 0 114.755 117.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-801 -353.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(795.246 347.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M92.319,6H20.275A3.284,3.284,0,0,0,17,9.275v26.2a3.284,3.284,0,0,0,3.275,3.275H39.923v75.319a3.284,3.284,0,0,0,3.275,3.275H92.319a3.284,3.284,0,0,0,3.275-3.275V9.275A3.284,3.284,0,0,0,92.319,6Z",
    transform: "translate(24.914 0.001)",
    fill: "#ffc850"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(41.913 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M33.275,28.924h13.1a3.266,3.266,0,0,0,2.315-.96L65.063,11.591A3.274,3.274,0,0,0,60.432,6.96L45.018,22.374H33.275a3.275,3.275,0,1,0,0,6.55Z",
    transform: "translate(12.573 -6)",
    fill: "#fe6f59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M62.338,79.455a3.266,3.266,0,0,0-2.315-.96H43.649V16.275a3.275,3.275,0,1,0-6.55,0V78.5H27.275a3.275,3.275,0,0,0,0,6.55H58.667l15.414,15.414a3.274,3.274,0,0,0,4.631-4.631Z",
    transform: "translate(-1.076 9.924)",
    fill: "#fe6f59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M53.023,25.649a3.276,3.276,0,0,0-3.275-3.275H38L22.591,6.96a3.274,3.274,0,0,0-4.631,4.631L34.334,27.964a3.266,3.266,0,0,0,2.315.96h13.1A3.276,3.276,0,0,0,53.023,25.649Z",
    transform: "translate(-17 -6)",
    fill: "#fe6f59"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(70.755 16.973)",
    fill: "#7d1416"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 66,
    height: 93,
    rx: 6,
    transform: "translate(5.755 30.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(18.991 45.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M46.022,34.374H13.275A3.276,3.276,0,0,1,10,31.1V21.275A3.276,3.276,0,0,1,13.275,18H46.022A3.276,3.276,0,0,1,49.3,21.275V31.1A3.276,3.276,0,0,1,46.022,34.374ZM16.55,27.824h26.2V24.55H16.55Z",
    transform: "translate(-10 -18)",
    fill: "#c2c7d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(41.914 94.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M25.187,49.374a8.187,8.187,0,1,1,8.187-8.187A8.2,8.2,0,0,1,25.187,49.374Z",
    transform: "translate(-17 -33)",
    fill: "#fe6f59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(18.991 64.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M46.022,30.55H13.275a3.275,3.275,0,0,1,0-6.55H46.022a3.275,3.275,0,0,1,0,6.55Z",
    transform: "translate(-10 -24)",
    fill: "#c2c7d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(18.991 74.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M46.022,33.55H13.275a3.275,3.275,0,0,1,0-6.55H46.022a3.275,3.275,0,0,1,0,6.55Z",
    transform: "translate(-10 -27)",
    fill: "#c2c7d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(18.991 84.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M46.022,36.55H13.275a3.275,3.275,0,0,1,0-6.55H46.022a3.275,3.275,0,1,1,0,6.55Z",
    transform: "translate(-10 -30)",
    fill: "#c2c7d0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M3.951-.69a1.135,1.135,0,0,1-.341.835,1.143,1.143,0,0,1-.841.341A1.143,1.143,0,0,1,1.927.144,1.143,1.143,0,0,1,1.586-.7a1.143,1.143,0,0,1,.341-.841,1.143,1.143,0,0,1,.841-.341,1.143,1.143,0,0,1,.841.341A1.15,1.15,0,0,1,3.951-.69ZM1.8-2.7,1.548-9.024h2.34L3.635-2.7Z",
    transform: "translate(842.544 454.153)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendencias);
export default __webpack_public_path__ + "static/media/pendencias.6f86d251fec4ca4097f45e87f0ef122d.svg";
export { ForwardRef as ReactComponent };